import * as React from 'react'

interface ProductOptionsLink {
  originUrl: string
  sku: string
}

export const ProductOptionsLink = (props: ProductOptionsLink) => (
  <link
    rel="preload"
    as="fetch"
    href={`${props.originUrl}/e2/operation/product/product-options/${props.sku}`}
    crossOrigin="anonymous"
  />
)
